import { Box, CircularProgress } from '@material-ui/core';
import {
  useParams, Redirect,
} from "react-router-dom";
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../reduxhooks';
import { signIn } from '../redux/AccountRedux';
import { closeOverlayAndReset, openOverlay as openOverlayEditView, setValues } from '../redux/UIOverlayMeasurementEditViewRedux';
import { CartStateItem } from 'common-ts/dist/models/Cart';
import { APIRequestStatus } from 'common-ts/dist/models/APIRequestStatus';
import { fetchUserItemQRSize } from '../redux/MeasurementsRedux';
import { BodyMeasurementsForSize } from 'common-ts/dist/models/UserMeasurements';

export default function PageCreatePersonalSize() {
  let { userItemQRSizeId } = useParams<{ userItemQRSizeId: string }>();
  const dispatch = useAppDispatch();

  const currentUserItemQRSizeId = useAppSelector(state => state.userMeasurementsList.userItemQRSizeId);
  const currentUserItemQRSize = useAppSelector(state => state.userMeasurementsList.userItemQRSize); // userMeasurementsForItem
  const currentUserItemQRCartProductItem: CartStateItem = useAppSelector( state => state.userMeasurementsList.userItemQRCartProductItem); // cartProductItem
  const fetchUserItemQRSizeStatus = useAppSelector(state => state.userMeasurementsList.fetchUserItemQRSizeStatus);

  const productDict = useAppSelector(state => state.productsList.productsDictionary);
  
  // 02. Fetch user item QR size
  if (currentUserItemQRSizeId !== userItemQRSizeId && fetchUserItemQRSizeStatus !== APIRequestStatus.RequestInProgress) {
    dispatch(fetchUserItemQRSize(userItemQRSizeId));
  }

  // 03. If the user is signed in and has purchased AND the item size has been fetched, we open the edit size flow, and redirect to shop page
  if (currentUserItemQRSizeId === userItemQRSizeId) {
    dispatch(closeOverlayAndReset());
    dispatch(setValues({
      overlayType: 'edit',
      clothingType: currentUserItemQRCartProductItem.clothingType,
      fitType: currentUserItemQRCartProductItem.fitType,
      isFullScreen: true,
      currentMeasurementObject: {
        ...currentUserItemQRSize,
        adjustedMeasurements: currentUserItemQRSize.regularSize ? BodyMeasurementsForSize?.[currentUserItemQRSize.regularSize] : {},
      },
      productDetail: productDict[currentUserItemQRCartProductItem.productId],
      origin: 'qr-mktplc'
    }))
    dispatch(openOverlayEditView());

    return (<Redirect to={"/shop"} />);
  }

  // 04. If the user is signed in but has not purchased, we just return null / a blank page
  return (
    <Box style={{
      width: '100%',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <CircularProgress/>
    </Box>
    );

}
